import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Loading from "../../component/Loading/Loading";
import { useSelector } from "react-redux";
import AlertMsg from "../../component/AlertMsg/AlertMsg";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import useAxiosInstance from "../../services/useAxiosInstance";
import GlassmorphicModal from "../../component/ReusableComponents/GlassmorphicModal";
const AddEmployee = () => {
  const axiosInstance = useAxiosInstance();
  const history = useHistory();
  const roleId = useSelector((state) => state.auth.roleId);
  const communityId = useSelector((state) => state.auth.communityId);
  const userId = useSelector((state) => state.auth.userId);

  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });
  // Modal states
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showResultModal, setShowResultModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const handleBackClick = () => {
    history.goBack();
  };
  const employeeId = useSelector((state) => state.auth.employeeId);
  console.log(employeeId);
  const todayDate = new Date().toISOString();
  const [formData, setFormData] = useState({
    employeeDto: {
      activeStatus: true,
      dateOfJoining: todayDate,
      designationId: 0,
      employeeId: 0,
      employeeNo: "",
      managerId: null,
      userId: 0,
      leavingDate: ""
    },
    userDto: {
      activeStatus: true,
      emailId: "",
      emailIdIsVerified: true,
      firstName: "",
      isClient: false,
      lastLogin: todayDate,
      lastName: "",
      middleName: "",
      mobileIsVerified: true,
      mobileNumber: "",
      otp: 0,
      password: "",
      roleId: 0,
      createdDate: todayDate,
      modifiedById: null,
      modifiedDate: todayDate,
      userId: 0,
      userProfileUrl: null
    },
  });
  console.log(formData);
  useEffect(() => {
    if (roleId === 1004) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        employeeDto: {
          ...prevFormData.employeeDto,
          designationId: 2,
          managerId: employeeId,
        },
        userDto: {
          ...prevFormData.userDto,
          roleId: 1005,
        },
      }));
    }
  }, [roleId]);
  const [errors, setErrors] = useState({});
  const [designations, setDesignations] = useState([]);

  const [managers, setManagers] = useState([]);

  console.log(managers);

  useEffect(() => {
    axiosInstance
      .get(`/api/public/designation/getAll`)
      .then((response) => {
        setDesignations(response.data);
      })
      .catch((error) => {
        console.error("Error fetching designations:", error);
        setErrors("Failed to fetch designations");
      });
  }, []);
  useEffect(() => {
    axiosInstance
      .get(`/api/public/employee/getEmployeesByDesignation/1`)
      .then((response) => {
        setManagers(response.data);
      })
      .catch((error) => {
        console.error("Error fetching employees:", error);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let sanitizedValue = value;

    if (name === "userDto.mobileNumber") {
      sanitizedValue = value.replace(/[^0-9]/g, "");
      if (sanitizedValue.length > 10) {
        sanitizedValue = sanitizedValue.slice(0, 10);
      }
    }

    const updateNestedProperty = (formData, name, value) => {
      const dotIndex = name.indexOf(".");
      if (dotIndex !== -1) {
        const object = name.substring(0, dotIndex);
        const property = name.substring(dotIndex + 1);
        return {
          ...formData,
          [object]: {
            ...formData[object],
            [property]: value,
          },
        };
      } else {
        return {
          ...formData,
          [name]: value,
        };
      }
    };

    let updatedFormData = formData;
    if (name === "employeeDto.designationId") {
      updatedFormData = updateNestedProperty(
        formData,
        name,
        parseInt(sanitizedValue) !== 0 ? parseInt(sanitizedValue) : 0
      );

      if (sanitizedValue === "1") {
        updatedFormData.userDto.roleId = 1004;
      } else if (sanitizedValue === "2") {
        updatedFormData.userDto.roleId = 1005;
      }
    } else {
      updatedFormData = updateNestedProperty(
        updatedFormData,
        name,
        sanitizedValue
      );
    }

    setFormData(updatedFormData);

    if (e.target.classList.contains("error") && sanitizedValue) {
      e.target.classList.remove("error");
    }
  };
  const handlePhoneNumberChange = (value) => {
    const isValid = value && value.length >= 10;

    setFormData((prevFormData) => ({
      ...prevFormData,
      userDto: {
        ...prevFormData.userDto,
        mobileNumber: value || "",
      },
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      mobileNumber: isValid ? "" : "Phone number must be at least 10 digits",
    }));
  };

  const validateFormData = async (data) => {
    const errors = {};

    if (!data.userDto.firstName.trim()) {
      errors.firstName = "First name is required";
    }

    if (!data.userDto.lastName.trim()) {
      errors.lastName = "Last name is required";
    }

    if (!data.employeeDto.designationId || data.employeeDto.designationId === "") {
      errors.designationId = "Please select a designation";
    }

    if (!data.userDto.emailId || !data.userDto.emailId.trim()) {
      errors.emailId = "Please provide your email address.";
    } else if (!/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(data.userDto.emailId)) {
      errors.emailId = "Please provide a valid email address (lowercase letters only).";
    } else if (!data.userDto.emailId.endsWith('@gmail.com')) {
      errors.emailId = "Email must be a Gmail address";
    } else {
      const emailId = data.userDto.emailId;
      const isEmailAvailable = await handleEmailCheck(emailId);
      console.log(emailId);
      if (!isEmailAvailable) {
        console.log('ok');

      } else {
        errors.emailId = 'Email is already taken';
        console.log('not ok');

      }
    }

    if (!data.userDto.mobileNumber.trim()) {
      errors.mobileNumber = "Phone number is required";
    } else if (data.userDto.mobileNumber.length < 10) {
      errors.mobileNumber = "Phone number must be at least 10 digits";
    }

    return errors;
  };

  const handleEmailCheck = async (emailId) => {
    console.log("Checking email availability...");
    console.log(emailId);

    try {
      const response = await axiosInstance.get(`/api/user/check/email?emailId=${emailId} `);
      if (response.status === 200) {
        return false;
      }
      return true;
    } catch (error) {
      console.error('Error checking email:', error);
      return true;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const validationErrors = await validateFormData(formData);

    if (Object.keys(validationErrors).length === 0) {
      try {
        const response = await axiosInstance.post(`/api/public/employee/add`, formData);

        if (response.status === 200) {
          setErrors({});
          setModalMessage('Employee added successfully!');
          setShowResultModal(true);
          setAlert({
            visible: true,
            message: 'Employee added successfully!',
            type: 'success',
          });
          setTimeout(() => {
            history.goBack();
          }, 2500);
        } else {
          throw new Error("Failed to submit data");
        }
      } catch (error) {
        console.error("Error submitting data:", error.message);
        setModalMessage('Error adding Employee. Please try again.');
        setShowResultModal(true);
        setAlert({
          visible: true,
          message: 'Error adding Employee. Please try again.',
          type: 'error',
        });
      }
    } else {
      setErrors(validationErrors);
      setAlert({
        visible: true,
        message: 'Please correct the errors in the form.',
        type: 'error',
      });
    }

    setLoading(false);
  };

  const handleCancelClick = () => {
    setShowCancelModal(true);
  };

  const handleConfirmCancel = () => {
    setLoading(true);
    setFormData({
      employeeDto: {
        activeStatus: true,
        dateOfJoining: todayDate,
        designationId: 0,
        employeeId: 0,
        employeeNo: "",
        managerId: null,
        userId: 0,
      },
      userDto: {
        activeStatus: true,
        emailId: "",
        emailIdIsVerified: true,
        firstName: "",
        isClient: false,
        lastLogin: "",
        lastName: "",
        middleName: " ",
        mobileIsVerified: true,
        mobileNumber: "",
        otp: 0,
        password: " ",
        roleId: 0,
      },
    });
    setErrors({});
    setShowCancelModal(false);
    history.goBack();
    setLoading(false);
  };

  const [loading, setLoading] = useState(false);

  // Modal footers
  const cancelModalFooter = (
    <div className="flex justify-end space-x-2">
      <button
        className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50"
        onClick={() => setShowCancelModal(false)}
      >
        No, Keep Editing
      </button>
      <button
        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
        onClick={handleConfirmCancel}
      >
        Yes, Cancel
      </button>
    </div>
  );

  const resultModalFooter = (
    <div className="flex justify-end">
      <button
        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
        onClick={() => setShowResultModal(false)}
      >
        OK
      </button>
    </div>
  );

  return (
    <div className="bg-gray-50 min-h-screen md:p-4">
      {loading && <Loading />}
      {!loading && (
        <div className="max-w-7xl mx-auto">
          {alert.visible && (
            <AlertMsg
              message={alert.message}
              type={alert.type}
              onClose={() => setAlert({ ...alert, visible: false })}
            />
          )}

          <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
            <div className="flex justify-between items-center p-4 border-b border-gray-200">
              <h1 className="text-2xl font-bold text-gray-800">Add Employee</h1>
            </div>

            <div className="p-6">
              <form className="flex flex-wrap gap-6" onSubmit={handleSubmit}>
                <div className="w-full md:w-[calc(50%-1.5rem)]">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    First Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    maxLength={100}
                    id="firstName"
                    name="userDto.firstName"
                    className={`w-full rounded-md border ${errors.firstName ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    value={formData.userDto.firstName}
                    onChange={handleChange}
                  />
                  {errors.firstName && (
                    <p className="text-red-500 text-sm mt-1">{errors.firstName}</p>
                  )}
                </div>

                <div className="w-full md:w-[calc(50%-1.5rem)]">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Middle Name
                  </label>
                  <input
                    type="text"
                    maxLength={100}
                    id="middleName"
                    name="userDto.middleName"
                    className="w-full rounded-md border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={formData.userDto.middleName}
                    onChange={handleChange}
                  />
                </div>

                <div className="w-full md:w-[calc(50%-1.5rem)]">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Last Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    maxLength={100}
                    id="lastName"
                    name="userDto.lastName"
                    className={`w-full rounded-md border ${errors.lastName ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    value={formData.userDto.lastName}
                    onChange={handleChange}
                  />
                  {errors.lastName && (
                    <p className="text-red-500 text-sm mt-1">{errors.lastName}</p>
                  )}
                </div>

                <div className="w-full md:w-[calc(50%-1.5rem)]">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Email <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    maxLength={100}
                    id="emailId"
                    name="userDto.emailId"
                    className={`w-full rounded-md border ${errors.emailId ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    value={formData.userDto.emailId}
                    onChange={handleChange}
                  />
                  {errors.emailId && (
                    <p className="text-red-500 text-sm mt-1">{errors.emailId}</p>
                  )}
                </div>

                <div className="w-full md:w-[calc(50%-1.5rem)]">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Mobile No <span className="text-red-500">*</span>
                  </label>
                  <div className="phone-input-container">
                    <PhoneInput
                      placeholder="Enter phone number"
                      value={formData.userDto.mobileNumber}
                      maxLength={10}
                      onChange={handlePhoneNumberChange}
                      defaultCountry="US"
                      country={'us'}
                      containerClass="w-full"
                      inputClass={`form-control h-12 w-full rounded-md border ${errors.mobileNumber ? "border-red-500" : "border-gray-300"} text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                      buttonStyle={{
                        borderTopLeftRadius: '0.375rem',
                        borderBottomLeftRadius: '0.375rem',
                        border: '1px solid #e5e7eb'
                      }}
                      dropdownStyle={{
                        width: 'max-content'
                      }}
                      limitMaxLength="10"
                      inputProps={{
                        name: "clientRequest.userDto.mobileNumber",
                        required: true,
                        autoFocus: true,
                        placeholder: "Enter mobile number",
                        style: { padding: '20px 35px', width: '100%' },
                      }}
                    />
                  </div>
                  {errors.mobileNumber && (
                    <p className="text-red-500 text-sm mt-1">{errors.mobileNumber}</p>
                  )}
                </div>

                {roleId !== 1004 && (
                  <>
                    <div className="w-full md:w-[calc(50%-1.5rem)]">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Designation <span className="text-red-500">*</span>
                      </label>
                      <select
                        id="designationId"
                        name="employeeDto.designationId"
                        className={`w-full rounded-md border ${errors.designationId ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        value={formData.employeeDto.designationId}
                        onChange={handleChange}
                      >
                        <option value="">Select Designation</option>
                        {designations.map((designation) => (
                          <option
                            key={designation.designationId}
                            value={designation.designationid}
                          >
                            {designation.name}
                          </option>
                        ))}
                      </select>
                      {errors.designationId && (
                        <p className="text-red-500 text-sm mt-1">{errors.designationId}</p>
                      )}
                    </div>
                    {formData.employeeDto.designationId === 2 && (
                      <div className="w-full md:w-[calc(50%-1.5rem)]">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Reporting Manager
                        </label>
                        <select
                          id="managerId"
                          name="employeeDto.managerId"
                          className="w-full rounded-md border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                          value={formData.employeeDto.managerId}
                          onChange={handleChange}
                        >
                          <option value="">Select Manager</option>
                          {managers.map((manager) => (
                            <option
                              key={manager.employeeId}
                              value={manager.employeeId}
                            >
                              {manager.firstName}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                  </>
                )}

                <div className="w-full flex items-center justify-between mt-2">
                  <div className="text-sm text-red-500">* indicates required field</div>
                  <div className="flex gap-2">
                    <button
                      type="button"
                      onClick={handleCancelClick}
                      className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Cancel Confirmation Modal */}
      <GlassmorphicModal
        isOpen={showCancelModal}
        onClose={() => setShowCancelModal(false)}
        title="Confirm Cancel"
        size="sm"
        footer={cancelModalFooter}
      >
        <p className="text-gray-700">
          Are you sure you want to cancel? All entered information will be lost.
        </p>
      </GlassmorphicModal>

      {/* Result Modal */}
      {/* <GlassmorphicModal
        isOpen={showResultModal}
        onClose={() => setShowResultModal(false)}
        title={alert.type === 'sucasdfcess' ? "Success" : "Error"}
        size="sm"
        footer={resultModalFooter}
      >
        <p className="text-gray-700">{modalMessage}</p>
      </GlassmorphicModal> */}
    </div>
  );
};

export default AddEmployee;